const { countryCodeEnum } = require('@/constants/country')

module.exports = {
  info: {
    url: 'www.vtmarkets.com',
    urlCn: 'www.vtfxglobal.cn',
    urlTw: 'www.vtmarkets.com.tw',
    map: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.638612031567!2d-81.38410268509537!3d19.29807578696095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f25865f22a0eebd%3A0xcd06467def56ae29!2sThe Harbour Centre%2C 42 N Church St%2C George Town%2C Cayman Islands!5e0!3m2!1sen!2sau!4v1571113930600!5m2!1sen!2sau',
    address: `<span>4th Floor The Harbour Centre</span><br>
          <span> 42 N Church St</span><br>
          <span>George Town, Cayman Islands</span>`,
    loginAddress: `<span>Level 2, Suite 201, The Catalyst, 40 Silicon Avenue, Ebène</span><br>
          <span>Republic of Mauritius</span>`,
    email: 'info@vtmarkets.com',
    name: 'VT Markets Limited',
    depositEmail: 'info@vtmarkets.com',
    withdrawalEmail: 'info@vtmarkets.com',
  },
  withdrawSetup: { checkMethodMinAmount: false, cancelWithdraw: true },
  openLiveAccount: {
    choosePlatform: [
      {
        value: 'mt5',
        label: 'common.choosePlatform.mt5',
      },
      {
        value: 'mt4',
        label: 'common.choosePlatform.mt4',
      },
    ],
    chooseLiveType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/standardStpSwapFree.png'),
        value: 'swapFreeStandardSTP',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
      {
        img: require('@/assets/images/openAccount/rawEcnSwapFree.png'),
        value: 'swapFreeRawECN',
      },
      {
        img: require('@/assets/images/openAccount/pamm.png'),
        value: 'PAMM',
      },
      {
        img: require('@/assets/images/openAccount/classicStp.png'),
        value: '9',
      },
    ],
    chooseRegisterType: [
      {
        img: require('@/assets/images/openAccount/standardStp.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/openAccount/standardStpSwapFree.png'),
        value: 'swapFreeStandardSTP',
      },
      {
        img: require('@/assets/images/openAccount/rawEcn.png'),
        value: 'rawECN',
      },
      {
        img: require('@/assets/images/openAccount/rawEcnSwapFree.png'),
        value: 'swapFreeRawECN',
      },
      {
        img: require('@/assets/images/openAccount/classicStp.png'),
        value: '9',
      },
    ],
    mt4DemoChooseType: [
      {
        img: require('@/assets/images/demoAccount/standardSTP.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/demoAccount/rawECN.png'),
        value: 'rawECN',
      },
    ],
    mt5DemoChooseType: [
      {
        img: require('@/assets/images/demoAccount/standardSTP.png'),
        value: 'standardSTP',
      },
      {
        img: require('@/assets/images/demoAccount/rawECN.png'),
        value: 'rawECN',
      },
    ],
    chooseCurrency: [
      {
        img: require('@/assets/images/openAccount/USD.png'),
        value: '$ USD',
        currency: 'USD',
        symbolLabel: 'currency.usd.symbolLabel',
      },
      {
        img: require('@/assets/images/openAccount/AUD.png'),
        value: '$ AUD',
        currency: 'AUD',
        symbolLabel: 'currency.aud.symbolLabel',
      },
      {
        img: require('@/assets/images/openAccount/GBP.png'),
        value: '£ GBP',
        currency: 'GBP',
        symbolLabel: 'currency.gbp.symbolLabel',
      },
      {
        img: require('@/assets/images/openAccount/CAD.png'),
        value: '$ CAD',
        currency: 'CAD',
        symbolLabel: 'currency.cad.symbolLabel',
      },
      {
        img: require('@/assets/images/openAccount/EUR.png'),
        value: '€ EUR',
        currency: 'EUR',
        symbolLabel: 'currency.eur.symbolLabel',
      },
    ],
    chooseLeverage: [100, 200, 300, 400, 500],
    chooseBalance: [
      { value: 1000, name: '$1000' },
      { value: 2500, name: '$2,500' },
      { value: 5000, name: '$5k' },
      { value: 10000, name: '$10k' },
      { value: 25000, name: '$25k' },
      { value: 50000, name: '$50k' },
      { value: 100000, name: '$100k' },
    ],
    getAgreeCondition: 'openAdditAcc.cima.disclaimer',
  },
  getMetaTraderLinks: {
    mt4: {
      Windows: 'https://download.mql5.com/cdn/web/11079/mt4/vtmarkets4setup.exe',
      MacOS: '',
      iPhone: 'https://itunes.apple.com/cn/app/metatrader-4/id496212596?mt=8',
      Android: 'https://play.google.com/store/apps/details?id=net.metaquotes.metatrader4',
      WebTrader: 'https://webtrader.vtmarkets.com/',
    },
    mt5: {
      Windows: 'https://download.mql5.com/cdn/web/vt.markets.pty/mt5/vtmarkets5setup.exe',
      MacOS: '',
      iPhone: 'https://download.mql5.com/cdn/mobile/mt5/ios?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202',
      Android:
        'https://download.mql5.com/cdn/mobile/mt5/android?server=VTMarkets-Demo,VTMarkets-Live,VTMarkets-Live%202',
      WebTrader: 'www3.vtmt5web.com',
    },
  },
  bankInfoDetails: {
    bank_name: 'Barclays Plc',
    bank_address: '1 Churchill Place, Canary Wharf, London, E14, 5RB, UK',
    account_name: 'Barclays-Vantage International Group Limited',
    account_number: {
      AUD: { show: true, value: '4391 8677' },
      USD: { show: true, value: '7892 2222' },
      GBP: { show: true, value: '9321 9208' },
      EUR: { show: true, value: '6964 9500' },
      CAD: { show: true, value: '7892 2222' },
    },
    beneficiary_address: 'Artemis House, 67 Fort Street, P.O. Box 2775, Grand Cayman, KY1-1111, Cayman Islands',
    sort_code: '20-00-00',
    swift_code: 'BARC GB22',
    IBAN: {
      AUD: { show: true, value: 'GB21 BARC 2000 0043 9186 77' },
      USD: { show: true, value: 'GB41 BARC 2000 0078 9222 22' },
      GBP: { show: true, value: 'GB97 BARC 2000 0093 2192 08' },
      EUR: { show: true, value: 'GB36 BARC 2000 0069 6495 00' },
      CAD: { show: true, value: 'GB41 BARC 2000 0078 9222 22' },
    },
  },
  banner(url) {
    return [
      {
        rightSideImg: require('@/assets/images/banner/person_9.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'banner.affiliateChallengerCup.title',
        subTitle: 'banner.affiliateChallengerCup.subTitle',
        buttonLink: 'https://www.vtaffiliates.com/challenger-cup-2023/',
        buttonText: 'banner.affiliateChallengerCup.buttonText',
        extraClass: 'info_left',
        imgClass: 'img_wrap',
        bannerVersion: 'v6',
        iosAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        andriodAppLink: 'https://vtmarketsapp.onelink.me/CD7D/yn2fw5mp',
        tncLink: 'https://www.vtaffiliates.com/challenger-cup-2023/',
        tncText: 'banner.tncText',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.THAILAND]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.BANGLADESH]: true,
          [countryCodeEnum.MALAYSIA]: true,
          [countryCodeEnum.JAPAN]: true,
          [countryCodeEnum.KOREA]: true,
          [countryCodeEnum.INDIA]: true,
          [countryCodeEnum.PHILIPPINES]: true,
        },
        onlyForCountries: null,
      },
      {
        rightSideImg: require('@/assets/images/banner/person_6.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'We make trading easy for you',
        subTitle:
          'With our award-winning customer service and powerful platforms, you have all the support you need to start trading.',
        buttonLink: `/depositFunds`,
        buttonText: 'Deposit Now',
        extraClass: ['info_left', 'title_single_line'],
        bannerVersion: 'v3',
        excludeCountries: [
          countryCodeEnum.PAKISTAN,
          countryCodeEnum.INDONESIA,
          countryCodeEnum.BANGLADESH,
          countryCodeEnum.SOUTH_AFRICA,
          countryCodeEnum.CHINA,
          countryCodeEnum.HONG_KONG,
          countryCodeEnum.MACAO,
          countryCodeEnum.TAIWAN,
        ],
        onlyForCountries: null,
      },
      {
        img: require('@/assets/images/banner/banner_new.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Enjoy Your Trading Experience Anytime, Anywhere',
        bannerVersion: 'v1',
        excludeCountries: null,
        onlyForCountries: {
          [countryCodeEnum.TAIWAN]: true,
          [countryCodeEnum.HONG_KONG]: true,
        },
      },
      {
        rightSideImg: require('@/assets/images/banner/person_1.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Gain advantage with <br> Extra trading power',
        subTitle: 'Get credit bonus for every deposit made to your live account up to $10,000!',
        buttonLink: `/depositBonus`,
        buttonText: 'Deposit Now',
        extraClass: 'info_left',
        bannerVersion: 'v3',
        tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5495&utm_campaign=clientportal',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.TAIWAN]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.THAILAND]: true,
          [countryCodeEnum.LAOS]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.MALAYSIA]: true,
          [countryCodeEnum.TURKEY]: true,
        },
        onlyForCountries: null,
      },
      {
        rightSideImg: require('@/assets/images/banner/person_2.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Empowering your investment <br> With everyday market insights',
        subTitle:
          'VT Markets Daily Newsletter provides you a deep & reliable multi-dimensional market insights and boost your trading.',
        buttonLink: `/dailyNewsletter`,
        buttonText: 'Sign up',
        extraClass: 'info_left',
        bannerVersion: 'v3',
        tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5490&utm_campaign=clientportal',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
        },
        onlyForCountries: null,
      },
      {
        rightSideImg: require('@/assets/images/banner/person_3.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Start your trading & earn <br> cash bonus',
        subTitle: 'Get your trading credit converted into cash for every trade you placed!',
        buttonLink: `https://go.vtmarkets.com/visit/?bta=35164&nci=5491&utm_campaign=CP`,
        buttonText: 'Sign up',
        extraClass: 'info_left',
        bannerVersion: 'v3',
        tncLink: 'https://go.vtmarkets.com/visit/?bta=35164&nci=5491&utm_campaign=clientportal ',
        excludeCountries: {
          [countryCodeEnum.CHINA]: true,
          [countryCodeEnum.HONG_KONG]: true,
          [countryCodeEnum.MACAO]: true,
          [countryCodeEnum.TAIWAN]: true,
          [countryCodeEnum.VIETNAM]: true,
          [countryCodeEnum.THAILAND]: true,
          [countryCodeEnum.LAOS]: true,
          [countryCodeEnum.INDONESIA]: true,
          [countryCodeEnum.PAKISTAN]: true,
          [countryCodeEnum.TURKEY]: true,
          [countryCodeEnum.MALAYSIA]: true,
        },
        onlyForCountries: null,
      },
      {
        rightSideImg: require('@/assets/images/banner/person_4.png'),
        smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
        title: 'Trade on the go',
        subTitle: 'Download VT Markets App and enjoy the all-in-one trading experience',
        extraClass: 'info_left',
        downloadPic: true,
        bannerVersion: 'v3',
        excludeCountries: null,
        onlyForCountries: null,
      },
      // {
      //   rightSideImg: require('@/assets/images/banner/person_5.png'),
      //   smallBgImg: require('@/assets/images/banner/page-header@3x.png'),
      //   title: 'Good experiences are <br> worth sharing',
      //   subTitle:
      //     'Refer a friend and receive a consecutive cash bonus as they register, fund and trade with a live account.',
      //   buttonLink: `/referFriends`,
      //   buttonText: 'Start referring',
      //   extraClass: 'info_left',
      //   bannerVersion: 'v3',
      //   tncLink:
      //     'https://www.vtmarkets.com/my/promotions/friend-referral/refer-a-friend/#:~:text=View%20terms%20and%20conditions',
      //   excludeCountries: {
      //     [countryCodeEnum.CHINA]: true,
      //     [countryCodeEnum.HONG_KONG]: true,
      //     [countryCodeEnum.MACAO]: true,
      //     [countryCodeEnum.TAIWAN]: true,
      //     [countryCodeEnum.VIETNAM]: true,
      //     [countryCodeEnum.THAILAND]: true,
      //     [countryCodeEnum.INDONESIA]: true,
      //     [countryCodeEnum.PAKISTAN]: true,
      //     [countryCodeEnum.BANGLADESH]: true,
      //     [countryCodeEnum.SOUTH_AFRICA]: true,
      //     [countryCodeEnum.TURKEY]: true,
      //     [countryCodeEnum.MALAYSIA]: true,
      //   },
      //   onlyForCountries: null,
      // },
    ]
  },
  getWithdrawMethods: {
    1: 'Credit/Debit Card',
    2: {
      1: 'Bank Transfer (Australia)',
      2: 'Bank Transfer (International)',
      3: 'Bank Transfer (China)',
    },
    3: 'Skrill / Neteller',
    4: 'Union Pay',
    5: 'Internet Banking (Thailand)',
    6: 'Internet Banking (Malaysia)',
    7: 'FasaPay',
    8: 'Internet Banking (Vietnam)',
    9: 'Internet Banking (Nigeria)',
    24: 'Internet Banking (India)',
    31: 'Skrill',
    32: 'Neteller',
    33: 'Paypal',
    34: 'Cryptocurrency-Bitcoin',
    36: 'Cryptocurrency-USDT',
    37: 'Bitwallet',
    39: 'Internet Banking (Indonesia)',
    40: 'Internet Banking (Philippine)',
    47: 'Internet Banking (Laos)',
    48: 'DasshpeUPI',
    49: 'Internet Banking (Hong Kong)',
    61: 'Perfect Money',
    63: 'Internet Banking (Mexico)',
    64: 'Pagsmile',
    65: 'Local Depositor',
    66: 'FPX2C2P',
    67: 'Nigeria Local Bank Transfer',
    99: 'Interac e-Transfer',
    115: 'E-Wallet (Bangladesh)',
    129: 'International Bank Transfer-International'
  },
  restrictDepositFundsByCountries: [
    4575, //Canada
  ],
  restrictOpenAdditionAccountCountries: [
    4575, //Canada
  ],
}
